PJQ.Tooltip = class {
	constructor(el, options = {}) {
		if (el == null && _.size(options.container) > 0) {
			this.$el = $('<div>', {
				class: 'position-absolute wd-100 ht-100 left-0 top-0'
			});
			options.container.append(this.$el);
		}
		else {
			this.$el = el instanceof $ ? el : $(el);
		}

		if (!options.show) {
			this.$el.addClass('popup-trigger');
		}

		this.options = _.defaults(options, {
			placement: 'auto',
			trigger: options.show ? 'focus' : 'hover',
			html: true,
			sanitize: false,
			allowMultiple: false,
			template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Tooltip-Default')
		});
		this.init();
	}

	init() {
		this.getTemplate(_.bind(function ($tmpl) {
			this.$el.popover(_.defaults({
				content: _.bind(function () {
					return $tmpl.outerHTML();
				}, this)
			}, _.omit(this.options, 'template')));

			if (this.options.show) {
				this.$el.popover('show');
			}
			else if (_.size(this.options.container) > 0) {
				let self = this;
				this.options.container.off('click.tooltip');
				this.options.container.on('click.tooltip', function (e) {
					if ($(e.target).closest('.popup-trigger').length === 0) {
						self.options.container.children('.popover').popover('hide');
					}
				});

				if (!this.options.allowMultiple) {
					this.$el.off('show.bs.popover');
					this.$el.on('show.bs.popover', function () {
						self.options.container.children('.popover').not(this).popover('hide');
					});

					if (typeof this.options.onShow === 'function') {
						this.options.onShow(this);
					}
				}
			}

			if (typeof this.options.afterRender === 'function') {
				this.options.afterRender(this);
			}
		}, this))
	}

	getTemplate(callback) {
		this.options.template.render(this.renderData(), callback);
	}

	renderData() {
		if (this.options.renderData != null) {
			if (typeof this.options.renderData === 'function') {
				return this.options.renderData();
			}
			return this.options.renderData;
		}
		return {
			title: this.options.title
		};
	}

	show() {
		this.$el.popover('show');
	}

	hide() {
		this.$el.popover('hide');
	}

	remove() {
		this.$el.popover('dispose');
		if (_.size(this.options.container) > 0) {
			this.options.container.find('.popover').remove();
		}
		this.$el.off('show.bs.popover').off('shown.bs.popover');
		this.options.container.off('click.tooltip');
	}
};